import React from 'react';
import { styled } from '@mui/material/styles';
import { NAV_TEXT_COLOR, ICON_SIZE } from './navConstants';

const StyledIcon = styled('span')({
  display: 'block',
  flexShrink: 0,
  width: ICON_SIZE,
  height: ICON_SIZE,
  backgroundColor: NAV_TEXT_COLOR,
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
});

interface NavIconImageProps {
  src: string;
}

/**
 * Renders a hosted SVG nav icon (from public/icons) as a CSS mask so it can
 * be tinted with `background-color`, matching the sizing/color previously
 * provided by MUI icon components.
 */
export const NavIconImage: React.FC<NavIconImageProps> = ({ src }) => (
  <StyledIcon
    data-testid="nav-icon"
    aria-hidden="true"
    style={{
      WebkitMaskImage: `url(${src})`,
      maskImage: `url(${src})`,
    }}
  />
);
